import React, { FC } from 'react';
import styled from 'styled-components';
import { noop } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import { Tab, Tabs } from '@cld/tabs';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';
import { AccountCredentials } from './AccountCredentials';

const Root = styled.div`
  min-width: calc(${globalTheme.spacing.lg} * 23);
  display: flex;
  flex-direction: column;

  ${Tabs} > * {
    flex: 1;
  }

  ${Tab} {
    padding-right: 0;
    padding-left: 0;
  }
`;

const AccountCredentialsWrapper = styled.div`
  flex: 1;

  & > * {
    height: 100%;
  }
`;

enum LoginModalTabId {
  AccountCredentials = 'AccountCredentials',
  SignUp = 'signUp',
}

export const Main: FC = () => {
  const analytics = useAnalytics();

  return (
    <Root data-test="login-window">
      <Tabs activeTabId={LoginModalTabId.AccountCredentials}>
        <Tab id={LoginModalTabId.AccountCredentials} aria-controls="contents" onClick={noop}>
          <FormattedMessage {...messages['loginModal.main.accountCredentials.label']} />
        </Tab>
        <a href="https://cloudinary.com/users/register/free" target="_blank" rel="noopener noreferrer">
          <Tab id={LoginModalTabId.SignUp} onClick={() => analytics('sign up', 'intent to sign up')}>
            <FormattedMessage {...messages['loginModal.main.signUp.label']} />
          </Tab>
        </a>
      </Tabs>
      <AccountCredentialsWrapper id="contents" aria-labelledby={LoginModalTabId.AccountCredentials}>
        <AccountCredentials />
      </AccountCredentialsWrapper>
    </Root>
  );
};
